module.exports = __webpack_public_path__ + "static/1-cb066a4eb7f8d2f432757786f855dda9.png";